import { OrderHistoryProvider } from 'hooks/context/OrderHistory';
import React, { memo } from 'react';
import { Menu } from 'routes/Menu';
import { RouteFC } from 'util/routeTypes';
import { Matryoshka } from '@clover-util/matryoshka';
import { InvoiceSummaryProvider } from 'routes/Checkout/context/InvoiceSummary';
import { SubmitOrderProvider } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { OrderDetailsProvider } from 'routes/Checkout/context/OrderDetails';
import { ApplePayProvider } from 'components/ApplePay/ApplePay';
import { OrderResponseSummaryProvider } from 'routes/Checkout/context/OrderResponseSummary';

const LANDING_PROVIDERS = [
  OrderHistoryProvider,
  InvoiceSummaryProvider,
  OrderDetailsProvider,
  OrderResponseSummaryProvider,
  ApplePayProvider,
  SubmitOrderProvider,
  Menu
];

export const LandingPage: RouteFC<{ children?: never }> = memo(function LandingPage() {
  return (
    <Matryoshka wrappers={LANDING_PROVIDERS} />
  );
});
